import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'


const vuexPersistence = new VuexPersistence({
  storage: window.sessionStorage
})

export default createStore({
  state: {
    accountInfo: null
  },
  getters: {
  },
  mutations: {
    setAccountInfo(state,payload){
      state.accountInfo = payload;
    }
  },
  actions: {
    setAccountInfo({commit},payload){
      commit('setAccountInfo',payload);
    }
  },
  modules: {
  },
  plugins: [vuexPersistence.plugin]
})
